// const canvas = document.createElement('canvas');

/**
 * Convert array buffer to image. Returns a promise that resolves to an Image object for the bytes in arrayBuffer
 *
 * @param arrayBuffer - arrayBuffer with bytes for a web image (e.g. JPEG, PNG, etc)
 * @returns {Promise} Promise that resolves to an Image object
 */
export default function (arrayBuffer) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const arrayBufferView = new Uint8Array(arrayBuffer);
    const blob = new Blob([arrayBufferView]);
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(blob);

    image.src = imageUrl;
    image.onload = () => {
      resolve(image);

/*
      let context = canvas.getContext('2d');
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);

      let imageData = context.getImageData(0, 0, image.naturalWidth, image.naturalHeight);
      let data = imageData.data;
      // console.log("data", data);

      for (var i = 0; i < data.length; i += 4) {
        // data[i]     = 255 - data[i];     // red
        // data[i + 1] = 255 - data[i + 1]; // green
        // data[i + 2] = 255 - data[i + 2]; // blue

        // data[i]     = data[i];     // red
        // data[i + 1] = 0; // green
        // data[i + 2] = 0; // blue

        data[i]     = data[i + 1];     // red
        data[i + 1] = data[i + 1]; // green
        data[i + 2] = data[i + 1]; // blue
      }

      context.putImageData(imageData, 0, 0);

      canvas.toBlob(function(blob) {
        const newImg = new Image();
        const url = URL.createObjectURL(blob);

        newImg.src = url;
        newImg.onload = function() {
          // no longer need to read the blob so it's revoked
          resolve(newImg);
          URL.revokeObjectURL(url);
        };
      });
*/

      urlCreator.revokeObjectURL(imageUrl);
    };

    image.onerror = (error) => {
      urlCreator.revokeObjectURL(imageUrl);
      reject(error);
    };
  });
}
